import { Cart } from '@pegasus/cart';

export const SET_CART = 'cart/SET_CART';

export const RESET_CART = 'cart/RESET_CART';

export const setCart = (cart: Cart) => ({
    type: SET_CART as typeof SET_CART,
    payload: {
        cart,
    },
});

export const resetCart = () => ({
    type: RESET_CART as typeof RESET_CART,
});

export type Actions =
    | ReturnType<typeof resetCart>
    | ReturnType<typeof setCart>;
